export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4800.74ef9d9a.jpg";